/* ==========================================================================
   ZAHARA PARFUM
   JavaScript mínimo. Sin librerías, sin dependencias.
   Todo degrada bien: si el JS falla, la tienda sigue funcionando.
   ========================================================================== */
(function () {
  'use strict';

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- agregar al carrito desde la tarjeta, sin salir de la página ---------- */
  $$('[data-quick-add]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('button');
      var label = form.querySelector('[data-label]');
      if (!btn || btn.disabled) return;
      var original = label ? label.textContent : btn.textContent;
      btn.disabled = true;
      if (label) label.textContent = 'Agregando…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          if (label) label.textContent = 'Agregado ✓';
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          var count = $('[data-cart-count]');
          if (count) count.textContent = cart.item_count;
        })
        .catch(function () {
          if (label) label.textContent = 'No se pudo, probá otra vez';
        })
        .finally(function () {
          setTimeout(function () {
            if (label) label.textContent = original;
            btn.disabled = false;
          }, 1700);
        });
    });
  });

  /* ---------- menú móvil ---------- */
  var toggle = $('[data-menu-toggle]');
  var menu   = $('[data-menu]');
  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      var open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Cerrar menú' : 'Abrir menú');
    });
  }

  /* ---------- pestañas de la ficha (acordeón accesible) ---------- */
  $$('[data-tab]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = btn.nextElementSibling;
      if (!panel) return;
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      panel.hidden = open;
    });
  });

  /* ---------- galería de producto ---------- */
  var mainImg = $('[data-main-image] img');
  if (mainImg) {
    $$('.pdp__thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-thumb');
        if (src) mainImg.setAttribute('src', src);
        $$('.pdp__thumb').forEach(function (t) { t.setAttribute('aria-selected', 'false'); });
        thumb.setAttribute('aria-selected', 'true');
      });
    });
  }

  /* ---------- selector de variantes ----------
     Los botones visibles manejan un <select> oculto que es el que
     realmente envía el formulario. Así funciona con y sin JS.        */
  var form   = $('[data-product-form]');
  var select = $('[data-variant-select]');
  if (form && select) {
    var chosen = [];
    $$('.pdp__swatches').forEach(function (group, i) {
      var active = $('[aria-checked="true"]', group);
      chosen[i] = active ? active.getAttribute('data-option-value') : null;
    });

    function syncVariant() {
      var wanted = chosen.filter(Boolean).join(' / ');
      var match = Array.prototype.find.call(select.options, function (o) {
        return o.textContent.trim() === wanted;
      });
      if (!match) return;
      select.value = match.value;

      var priceEl = $('[data-price]');
      if (priceEl && match.dataset.price) priceEl.textContent = match.dataset.price;

      var addBtn = $('button[name="add"]', form);
      if (addBtn) {
        var sold = match.disabled;
        addBtn.disabled = sold;
        addBtn.textContent = sold ? 'Agotado' : 'Agregar al carrito';
      }
    }

    $$('.swatch').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-option-index'), 10);
        var group = btn.closest('.pdp__swatches');
        $$('.swatch', group).forEach(function (b) { b.setAttribute('aria-checked', 'false'); });
        btn.setAttribute('aria-checked', 'true');
        chosen[idx] = btn.getAttribute('data-option-value');
        syncVariant();
      });
    });
  }

  /* ---------- cantidad en el carrito ---------- */
  $$('.qty').forEach(function (box) {
    var input = $('input', box);
    if (!input) return;
    $('[data-qty-down]', box).addEventListener('click', function () {
      input.value = Math.max(0, parseInt(input.value, 10) - 1);
    });
    $('[data-qty-up]', box).addEventListener('click', function () {
      input.value = parseInt(input.value, 10) + 1;
    });
  });

  /* ---------- orden y filtros de colección ---------- */
  var sort = $('[data-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  var filterForm = $('[data-filter-form]');
  if (filterForm) {
    filterForm.addEventListener('change', function () {
      var data = new FormData(filterForm);
      var params = new URLSearchParams();
      data.forEach(function (v, k) { if (v) params.append(k, v); });
      var sortBy = sort ? sort.value : null;
      if (sortBy) params.set('sort_by', sortBy);
      window.location.search = params.toString();
    });
  }

  /* ---------- mostrar/esconder el panel de filtros en celular ----------
     Sin JS los filtros quedan visibles siempre (nunca dependen del script
     para poder verse). Con JS, arrancan cerrados en pantallas chicas y
     el botón "Filtros" los abre y cierra. */
  var filtersToggle = $('[data-filters-toggle]');
  var filtersPanel = $('[data-filters]');
  if (filtersToggle && filtersPanel) {
    if (window.matchMedia('(max-width: 860px)').matches) {
      filtersPanel.setAttribute('data-closed', '');
    }
    filtersToggle.addEventListener('click', function () {
      var closed = filtersPanel.hasAttribute('data-closed');
      if (closed) { filtersPanel.removeAttribute('data-closed'); }
      else { filtersPanel.setAttribute('data-closed', ''); }
      filtersToggle.setAttribute('aria-expanded', closed ? 'true' : 'false');
    });
  }

  /* ---------- revelado al hacer scroll ---------- */
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- revelado al cargar (hero) ---------- */
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      $$('.reveal-load').forEach(function (el) { el.classList.add('is-in'); });
    });
  });

  /* ---------- slider de portada ---------- */
  var slider = $('[data-hero-slider]');
  if (slider) {
    var slides = $$('[data-hero-slide]', slider);
    var dots = $$('[data-hero-dot]', slider);
    var current = 0;
    var timer = null;
    var interval = parseInt(slider.getAttribute('data-autoplay'), 10) || 0;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function goTo(i) {
      if (i === current || !slides[i]) return;
      slides[current].classList.remove('is-active');
      dots[current] && dots[current].classList.remove('is-active');
      dots[current] && dots[current].setAttribute('aria-selected', 'false');
      current = i;
      slides[current].classList.add('is-active');
      dots[current] && dots[current].classList.add('is-active');
      dots[current] && dots[current].setAttribute('aria-selected', 'true');
    }

    function next() { goTo((current + 1) % slides.length); }

    function start() {
      if (!interval || slides.length < 2 || reduced) return;
      stop();
      timer = setInterval(next, interval);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); start(); });
    });
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', start);

    /* Rueda del mouse: solo el scroll de lado a lado (trackpad o
       shift+rueda) pasa a la siguiente o anterior diapositiva. El
       scroll normal de arriba a abajo mueve la página sin tocar el
       hero, para no interrumpir a quien solo quiere bajar la página. */
    var wheelLocked = false;
    slider.addEventListener('wheel', function (e) {
      if (slides.length < 2) return;
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      var delta = e.deltaX;
      var forward = delta > 8;
      var backward = delta < -8;
      if (forward && current < slides.length - 1) {
        e.preventDefault();
        if (wheelLocked) return;
        wheelLocked = true;
        stop();
        goTo(current + 1);
        setTimeout(function () { wheelLocked = false; }, 700);
      } else if (backward && current > 0) {
        e.preventDefault();
        if (wheelLocked) return;
        wheelLocked = true;
        stop();
        goTo(current - 1);
        setTimeout(function () { wheelLocked = false; }, 700);
      }
      /* En la primera o última diapositiva, no se llama preventDefault:
         el scroll sigue de largo y mueve la página con normalidad. */
    }, { passive: false });

    /* Swipe en celular: igual que la rueda, pero con el dedo. */
    var touchX = null;
    slider.addEventListener('touchstart', function (e) {
      touchX = e.touches[0].clientX;
      stop();
    }, { passive: true });
    slider.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      touchX = null;
      if (Math.abs(dx) < 40) { start(); return; }
      if (dx < 0 && current < slides.length - 1) goTo(current + 1);
      else if (dx > 0 && current > 0) goTo(current - 1);
      start();
    }, { passive: true });

    /* Arrastrar con el mouse: el gesto de swipe del trackpad a veces lo
       agarra Chrome para "ir atrás/adelante" en vez de mandarlo acá, así
       que este clic-y-arrastrá es la forma confiable de moverse de lado
       a lado con mouse o trackpad. */
    var dragX = null;
    var dragging = false;
    var dragMoved = 0;
    slider.addEventListener('mousedown', function (e) {
      dragX = e.clientX;
      dragging = true;
      dragMoved = 0;
      stop();
    });
    window.addEventListener('mousemove', function (e) {
      if (!dragging) return;
      dragMoved = Math.abs(e.clientX - dragX);
    });
    window.addEventListener('mouseup', function (e) {
      if (!dragging) return;
      dragging = false;
      var dx = e.clientX - dragX;
      dragX = null;
      if (Math.abs(dx) < 50) { start(); return; }
      if (dx < 0 && current < slides.length - 1) goTo(current + 1);
      else if (dx > 0 && current > 0) goTo(current - 1);
      start();
    });
    /* Si arrastró más de un pelín, el clic que sigue no debe activar el
       enlace de la diapositiva (si no, cada drag te manda a la colección). */
    slider.addEventListener('click', function (e) {
      if (dragMoved > 8) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    start();
  }

  /* ---------- header que se compacta al hacer scroll ---------- */
  var header = $('[data-header]');
  if (header) {
    var lastScrolled = null;
    var onScroll = function () {
      var scrolled = window.scrollY > 12;
      if (scrolled !== lastScrolled) {
        if (scrolled) header.setAttribute('data-scrolled', ''); else header.removeAttribute('data-scrolled');
        lastScrolled = scrolled;
      }
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }
})();
